module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/powerpoint-9034728d89ac84a07d68cb210b1cd451.svg";